import React from 'react';
import { Alert, Button, Container, Form, FormControl } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';

import {
  getMyAuthorizedAccounts,
  loginRequest,
  logoutRequest,
} from '../actions/auth';
import { showAlert } from '../components/AlertModal';
import FormInput from '../components/FormInput';
import LoginComponent from '../components/LoginComponent';

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      password: '',
      loading: false,
      success: false,
      error: false,
    };
  }

  componentDidMount() {}

  render() {
    const { t } = this.props;
    return (
      <Container style={{ maxWidth: 500, marginTop: 100, borderRadius: 5 }}>
        <LoginComponent
          onLoginSuccess={(response) => {
            getMyAuthorizedAccounts(
              (authorized_accounts) => {
                console.log(authorized_accounts.length);
                const role = response.account.role;
                const allow_private_login = true; // For testing purposes
                if (
                  role == 'private' &&
                  authorized_accounts.length == 0 &&
                  !allow_private_login
                ) {
                  logoutRequest(
                    () => {},
                    () => {},
                  );
                  showAlert(
                    'Private Account',
                    t('errors.pleaseUseMobileApp'),
                    () => {
                      this.props.history.push('login');
                    },
                    t('Login.getMobileApp'),
                    () => {
                      window.location.replace(t('links.website'));
                    },
                  );
                  return;
                }

                localStorage.setItem(
                  'AuthorizedAccounts',
                  JSON.stringify(authorized_accounts),
                );
                const targetRoute =
                  role == 'private' ? '/FindMoorings' : '/home';
                this.props.history.push(targetRoute);
                window.location.reload();
              },
              (error) => {},
            );
          }}
        />
      </Container>
    );
  }
}

export default withTranslation()(Login);
